import { CreditCardStatus } from '@nemuru-eng/js-api-client';

import { StatusDefinition, StatusTagType } from '@/config/types';
import { FunnelStageStep } from '@/types/funnelStageStep';

export const ALLOWED_CREDIT_CARD_STATUSES_FOR_MULTI_SELECT_FILTER = [
  CreditCardStatus.INITIAL,
  CreditCardStatus.REQUESTED,
  CreditCardStatus.ON_HOLD,
  CreditCardStatus.APPROVED,
  CreditCardStatus.SIGNED,
  CreditCardStatus.CONFIRMED,
  CreditCardStatus.CAPTURED,
  CreditCardStatus.PAID,
  CreditCardStatus.DENIED,
  CreditCardStatus.CANCELLED,
  CreditCardStatus.DESISTED,
  CreditCardStatus.EXPIRED,
];

export const CREDIT_CARD_STATUS_DEFINITIONS = {
  [CreditCardStatus.INITIAL]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_INITIAL',
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'dark',
    SECTION_T_ID: FunnelStageStep.STARTED,
  },
  [CreditCardStatus.ON_HOLD]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_ON_HOLD',
    colorPaletteName: StatusTagType.INFO,
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.ON_HOLD,
  },
  [CreditCardStatus.REQUESTED]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_REQUESTED',
    colorPaletteName: StatusTagType.INFO,
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.REQUESTED,
  },
  [CreditCardStatus.APPROVED]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_APPROVED',
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.APPROVED,
  },
  [CreditCardStatus.CONFIRMED]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_CONFIRMED',
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'dark',
    SECTION_T_ID: FunnelStageStep.CONFIRMED,
  },
  [CreditCardStatus.CAPTURED]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_CAPTURED',
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'dark',
    SECTION_T_ID: FunnelStageStep.CONFIRMED,
  },
  [CreditCardStatus.SIGNED]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_SIGNED',
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.APPROVED,
  },
  [CreditCardStatus.PAID]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_PAID',
    colorPaletteName: StatusTagType.SUCCESS,
    colorType: 'dark',
    SECTION_T_ID: FunnelStageStep.PAID,
  },
  [CreditCardStatus.DESISTED]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_DESISTED',
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.DESISTED,
  },
  [CreditCardStatus.EXPIRED]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_EXPIRED',
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.EXPIRED,
  },
  [CreditCardStatus.CANCELLED]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_CANCELLED',
    colorPaletteName: StatusTagType.DEFAULT,
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.CANCELLED,
  },
  [CreditCardStatus.DENIED]: {
    DESCRIPTION_T_ID: 'CREDIT_CARD_STATUS_DENIED',
    colorPaletteName: StatusTagType.ERROR,
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.DENIED,
  },
} as const satisfies CheckoutSessionStatusStyleDefinitions;

interface CheckoutSessionStatusStyleDefinitions {
  [key: string]: StatusDefinition;
}
